/**
 * JSON CANÔNICO: as chaves de todo objeto em ordem, recursivamente; os arrays
 * na ordem em que vieram; `undefined` some (como no `JSON.stringify`).
 *
 * Existe para o hash de uma versão de rotina ser o MESMO na API, que guarda, e
 * no daemon, que confere antes de rodar (F3-desenho §5): o Postgres devolve um
 * `jsonb` com as chaves na ordem DELE, e um hash sobre o `JSON.stringify` cru
 * divergiria sem que nada tivesse mudado.
 *
 * Puro, sem `node:crypto`: o painel importa o barril do `shared`. O hash em si
 * mora em `@remoto/shared/toolkit-hash`.
 */
export function jsonCanonico(valor: unknown): string {
  return JSON.stringify(ordenar(valor));
}

function ordenar(valor: unknown): unknown {
  if (Array.isArray(valor)) return valor.map((v) => (v === undefined ? null : ordenar(v)));
  if (valor !== null && typeof valor === 'object') {
    const saida: Record<string, unknown> = {};
    for (const chave of Object.keys(valor).sort()) {
      const v = (valor as Record<string, unknown>)[chave];
      if (v !== undefined) saida[chave] = ordenar(v);
    }
    return saida;
  }
  return valor;
}
